import { Component, AfterViewInit } from '@angular/core';
import { user_zone_lang } from "../../language/user_zone";
import { MyserviceService } from '../../provider/myservice.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as L from 'leaflet';

@Component({
  selector: 'app-user-zone',
  templateUrl: './user-zone.component.html',
  styleUrls: ['./user-zone.component.scss']
})
export class UserZoneComponent implements AfterViewInit {
  map;
  lat = 19.1681;
  lon = 99.9023;
  municipality_id = '';
  lang = '';
  language: any;
  isLoading = true;
  showPage = false;
  showZone = false;
  search_user = "";
  users: any;
  all_users: any;
  user_local = null;
  user = [];
  geoJson: any;
  all_marker = [];
  marker;
  mapbox;
  //drop down 
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'zone_id',
    textField: 'zone_name',
    selectAllText: this.lang == 'EN' ? 'SelectAll' : 'เลือกทั้งหมด',
    unSelectAllText: this.lang == 'EN' ? 'Notselect' : 'ไม่เลือกทั้งหมด',
    itemsShowLimit: 50,
    allowSearchFilter: true
  };

  zone_user = [];
  zone_users = [];
  zones = [];
  all_zones = [];

  constructor(private service: MyserviceService, private route: ActivatedRoute, private router: Router) {
    this.language = user_zone_lang[this.lang];
  }

  ngAfterViewInit(): void {

  }

  private initMap(): void {
    var streets_satellite = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Mapbox',
      tileSize: 512,
      zoomOffset: -1,
      id: 'mapbox/satellite-v9',
      accessToken: 'pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw'
    })
    // ===================================================================================
    var mapbox_streets = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Mapbox',
      tileSize: 512,
      zoomOffset: -1,
      id: 'mapbox/streets-v11',
      accessToken: 'pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw'
    })


    var wmslayer = L.tileLayer.wms('http://203.150.210.26:8080/DeeMap_Msd01/gwc/service/wms', {
      layers: 'cite:Pattaya',
      format: 'image/png8',
      transparent: true,
    })

    var polygon = L.tileLayer.wms('http://203.150.210.26:8080/DeeMap_Msd01/wms?', {
      layers: 'pattaya_200463',
      format: 'image/png',
      transparent: true,
    })

    var baseLayers = {
      "Satellite_mapbox": streets_satellite,
      "Streets_mapbox": mapbox_streets,
    };


    this.service.postData({}, "zone/get").then(async (e: any) => {
      const newdata = await e.data.map((feature: any) => {
        return {
          zone_id: feature.zone_id,
          id: feature.id,
          geometry: feature.coordinates,
          properties: feature.properties,
          type: feature.type,
          zone_name: feature.zone_name,
          block_coordinates: feature.block_coordinates,
        };
      });
      const newdata_ = await Promise.all(newdata);
      this.mapbox = newdata_;
      const bule = newdata_.filter((feature: any) => feature.zone_idd == null);

      var css =
        ".text-label { background-color: transparent; color: white; font-size: 13px; border: none; }";
      var style = document.createElement("style");
      style.type = "text/css";
      style.appendChild(document.createTextNode(css));
      document.head.appendChild(style);

      const zone = L.geoJSON(bule, {
        style: { color: "blue", fillOpacity: 0.4 },
        onEachFeature: (feature: any, layer: any) => {
          layer
            .bindTooltip(feature.zone_id, {
              permanent: true,
              direction: "center",
              className: "text-label",
              // opacity: 0.9
            })
            .openTooltip();
          layer.bindPopup(`<p style="font-size: 12px;">
          โซน: ${feature.zone_name}<br>
          </p>`

          );
          layer.on('mouseover', function () {
            this.openPopup();
          });
          layer.on('mouseout', function () {
            this.closePopup();
          });
        },
      });
      zone.addTo(this.map);



      const newGeoJsonLayer = L.geoJSON(bule, {
        style: { color: "blue", fillOpacity: 0.4 },
        onEachFeature: (feature: any, layer: any) => {
          layer
            .bindTooltip(feature.zone_name, {
              permanent: true,
              direction: "center",
              className: "text-label",
              // opacity: 0.9
            })
            .openTooltip();
        },
      });
      zone.addTo(this.map);

      this.map.on("zoomend", () => {
        if (this.map.getZoom() >= 15) {
          newGeoJsonLayer.addTo(this.map);
          layerControl.addOverlay(newGeoJsonLayer, "New GeoJSON");
          this.map.removeLayer(zone);
        } else {
          this.map.removeLayer(newGeoJsonLayer);
          layerControl.removeLayer(newGeoJsonLayer);
          zone.addTo(this.map);
        }
      });
    });

    this.map = L.map('map', {
      center: [this.lat, this.lon],
      zoom: 40,
      layers: [streets_satellite]
    });

    var layerControl = L.control.layers(baseLayers).addTo(this.map);
    // layerControl.addOverlay(wmslayer.addTo(this.map), 'Map Service Drone');
    // layerControl.addOverlay(polygon.addTo(this.map), 'ขอบเขต');
  }

  ngOnInit() {
    this.user_local = JSON.parse(sessionStorage.getItem('user'))
    this.municipality_id = JSON.parse(sessionStorage.getItem('municipality')).municipality_id;
    this.refreshData();
    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = user_zone_lang[this.lang];
      } else {
        this.language = user_zone_lang[this.lang];
        localStorage.setItem('lang', this.lang);
      }
    });
  }

  refreshData() {
    this.user = [];
    this.isLoading = true;
    this.search_user = "";
    this.service.postData({ municipality_id: this.municipality_id }, "user-location/get-user").then((result: any) => {
      this.user = [];
      this.users = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))
      this.all_users = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""));
      this.isLoading = false;
      this.showPage = true;
    }, (err) => {
      this.isLoading = false;
      Swal.fire({
        title: this.language.no_internet_alert,
        text: '',
        type: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
    });
  }

  delete_information(request) {
    if (request != undefined) {
      this.user = this.all_users.filter((item) => item.user_id == request.user_id);
    }

    if (this.user.length > 0) {
      Swal.fire({
        title: this.language.approve_title,
        text: this.language.notapprove_detail,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.language.inform_confirm,
        cancelButtonText: this.language.approve_cancel
      }).then((result) => {
        if (result.value) {
          this.zone_users = [];
          this.service.postData({ user_id: this.user[0].user_id, zone_users: this.zone_users }, "user-location/update-user-zone").then((result: any) => {
            debugger;
            if (!result.code) {
              Swal.fire({
                title: this.language.approve,
                text: '',
                type: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
              }).then((Swal_result) => {
                window.location.reload();
              })
            }
          }, err => {
            window.location.href = this.service.start_host
          })
        }
      });
    }
  }

  show_information(request) {
    if (request != undefined) {
      this.user = this.all_users.filter((item) => item.user_id == request.user_id);
    }

    if (this.user.length > 0) {
      this.showPage = false;
      this.showZone = true;
      this.service.postData({}, "user-location/get-zone").then((result: any) => {
        this.zones = result.data//JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))
        this.all_zones = result.data//JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""));
        console.log(this.zones);

        setTimeout(() => {
          this.service.postData({ user_id: this.user[0].user_id }, "user-location/get-user-zone").then((result: any) => {
            this.zone_user = [];
            this.zone_users = result.data//JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))
            console.log(this.zone_users);
            this.initMap();

            if (this.zone_users.length > 0) {
              for (var i = 0; i <= this.zone_users.length - 1; i++) {
                var customIcon = L.icon({
                  iconUrl: '../../../assets/img/marker-icon-2x.png',
                  iconSize: [30, 45],
                  iconAnchor: [23, 35],
                  popupAnchor: [-2, -38]
                });
                var marker = L.marker([this.zone_users[i].lat, this.zone_users[i].lon], { icon: customIcon }).addTo(this.map);
                this.map.setView([this.lat, this.lon], 13);
                this.all_marker.push(marker);

                if (i == this.zone_users.length - 1) {
                  this.lat = this.zone_users[i].lat;
                  this.lon = this.zone_users[i].lon;
                  this.map.panTo([this.lat, this.lon]);
                }

              }
            }
          });

        }, 500);

      })


    }
  }

  refresh() {
    this.showPage = true;
    this.showZone = false;
    this.user = [];
  }

  onItemSelect(item: any) {
    console.log(this.zone_users);
    this.updateMarker();
  }
  onSelectAll(items: any) {
    console.log(this.zone_users);
    this.zone_users = [];
    this.zone_users = items;
    this.updateMarker();
  }

  onItemDeSelect(deitem: any) {
    console.log(this.zone_users);
    this.updateMarker();
  }
  onDeSelectAll(items: any) {
    this.zone_users = [];
    console.log(this.zone_users);
    this.updateMarker();
  }

  updateMarker() {
    console.log(this.zone_users);

    if (this.all_marker.length > 0) {
      for (var mk = 0; mk <= this.all_marker.length - 1; mk++) {
        if (this.all_marker[mk]) { // check
          this.map.removeLayer(this.all_marker[mk]); // remove
          this.map.removeControl(this.all_marker[mk]); // remove
        }
      }

      this.all_marker = [];
    }

    if (this.zone_users.length > 0) {
      for (var i = 0; i <= this.zone_users.length - 1; i++) {
        this.zone_user = this.all_zones.filter((mkfillter) => mkfillter.zone_id == this.zone_users[i].zone_id);

        if (this.zone_user.length > 0) {
          var customIcon = L.icon({
            iconUrl: '../../../assets/img/marker-icon-2x.png',
            iconSize: [30, 45],
            iconAnchor: [23, 35],
            popupAnchor: [-2, -38]
          });
          var marker = L.marker([this.zone_user[0].lat, this.zone_user[0].lon], { icon: customIcon }).addTo(this.map);
          this.map.setView([this.lat, this.lon], 13);

          this.all_marker.push(marker);

          if (i == this.zone_users.length - 1) {
            this.lat = this.zone_user[0].lat;
            this.lon = this.zone_user[0].lon;
            this.map.panTo([this.lat, this.lon]);
          }
        }


      }


    }
  }

  save() {
    if (this.zone_users.length == 0) {
      Swal.fire({
        title: this.language.inform_title,
        text: this.language.inform_detail,
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: this.language.inform_confirm
      }).then((result) => {
        if (result.value) { }
      })
    }
    else {
      Swal.fire({
        title: this.language.approve_title,
        text: this.language.approve_detail,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.language.inform_confirm,
        cancelButtonText: this.language.approve_cancel
      }).then((Swal_result) => {
        if (Swal_result.value) {
          this.service.postData({ user_id: this.user[0].user_id, zone_users: this.zone_users }, "user-location/update-user-zone").then((result: any) => {
            // debugger;
            if (!result.code) {
              Swal.fire({
                title: this.language.approve,
                text: '',
                type: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
              }).then((Swal_result) => {
                window.location.reload();
              })
            }
          }, err => {
            window.location.href = this.service.start_host
          })
        }
      });
    }
  }

  delete() {

    Swal.fire({
      title: this.language.approve_title,
      text: this.language.notapprove_detail,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.language.inform_confirm,
      cancelButtonText: this.language.approve_cancel
    }).then((result) => {
      if (result.value) {
        this.zone_users = [];
        this.service.postData({ user_id: this.user[0].user_id, zone_users: this.zone_users }, "user-location/update-user-zone").then((result: any) => {
          debugger;
          if (!result.code) {
            Swal.fire({
              title: this.language.approve,
              text: '',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2000
            }).then((Swal_result) => {
              window.location.reload();
            })
          }
        }, err => {
          window.location.href = this.service.start_host
        })
      }
    });
  }
}

